import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LanguageAndCurrency } from 'src/app/services/languageAndCurrency.service';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  currency: string = 'VND';
  rate: number;
  listCurrency: string[] = ['USD', 'VND', 'EUR', 'INR', 'AUD'];
  private currencyChangeSubject = new BehaviorSubject<{ currency: string; rate: number }>({
    currency: this.currency,
    rate: 1,
  });
  currencyChanged$ = this.currencyChangeSubject.asObservable();

  constructor(
    private languageAndCurrency: LanguageAndCurrency,
  ) {
    let currencyConversationData = JSON.parse(
      localStorage.getItem('currency-conversation-data') || '{}'
    );
    if (this.listCurrency.includes(currencyConversationData.currency)) {
      this.currency = currencyConversationData.currency;
      this.rate = currencyConversationData.rate;
    }
    this.languageAndCurrency
      .notifyChangeLanguageCurrency()
      .subscribe(() => {
        let currencyConversationData = JSON.parse(
          localStorage.getItem('currency-conversation-data') || '{}'
        );
        if (this.listCurrency.includes(currencyConversationData.currency)) {
          this.currency = currencyConversationData.currency;
          this.rate = currencyConversationData.rate;
          this.currencyChangeSubject.next({
            currency: this.currency,
            rate: this.rate,
          });
        }        
      });
  }
}
